import { render, staticRenderFns } from "./EditHuman.vue?vue&type=template&id=6bf6b72f&scoped=true&"
import script from "./EditHuman.vue?vue&type=script&lang=js&"
export * from "./EditHuman.vue?vue&type=script&lang=js&"
import style0 from "./EditHuman.vue?vue&type=style&index=0&id=6bf6b72f&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf6b72f",
  null
  
)

export default component.exports